import React from 'react';
import Grid from '@material-ui/core/Grid';
import UsersTable from 'src/components/sharedComponents/Tablas/UsersTable';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import { permitsList } from 'src/constants/permits';

const AdminReportUserPage = ({
  handleOnChange, permisos, columns, users,
}) => {
  const minValue = permisos[permitsList.ADMIN_USUARIOS];

  return (
    <>
      <CardTitle
        title="Administración de usuarios"
        subTitle=" Edite permisos de visualización de reportes"
      />
      <Grid item xs={12} md={12} sm={12}>
        <UsersTable
          status
          dataTable={users}
          columns={columns}
          idPermisoTabla={minValue}
          handleOnChange={handleOnChange}
        />
      </Grid>
    </>
  );
};

export default AdminReportUserPage;
